/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_LearnInputs */

const en_footer_info_learn = /** @type {(inputs: Footer_Info_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn`)
};

/**
* | output |
* | --- |
* | "Learn" |
*
* @param {Footer_Info_LearnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_learn = /** @type {((inputs?: Footer_Info_LearnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_LearnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_learn(inputs)
});